import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Input } from '@/components/ui/inputs/input';
import { InputIcon } from '@/components/ui/inputs/input-icon';

const SearchForm = ({ itemSearchValue, setItemSearchValue }) => {
    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();

    const onSubmit = (data) => {
        setItemSearchValue(data?.name);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="mb-4">
            <Controller
                control={control}
                rules={{ minLength: 3, maxLength: 30 }}
                name="name"
                render={({ field }) => (
                    <InputIcon
                        {...field}
                        type="text"
                        placeholder="Search by Menu Item"
                        size="sm"
                        inputClassName="px-4"
                        errorData={{ minLength: '3', maxLength: '30' }}
                        errorType={errors?.name?.type}
                        className="w-full bg-white rounded-tl-lg rounded-bl-lg border placeholder:text-xs placeholder:font-rubik placeholder:text-[#A0A3BD] border-[#EFF0F6] overflow-hidden"
                        suffixIcon={<i className="lab lab-search-normal text-white"></i>}
                        suffixWrap={
                            <button type="submit" className="flex-shrink-0 size-[38px] text-center bg-primary flex items-center justify-center">
                                <i className="lab lab-search-normal text-white"></i>
                            </button>
                        }
                    />
                )}
            />
        </form>
    );
};

export default SearchForm;
